<template>
    <b-card :title="title">
        <b-card-header>
            <b-row>
                <b-col md="4" cols="12">
                    <b-form-select
                        id="input-order-item-type"
                        v-model="filters.order_item_type_id"
                        :options="types"
                        text-field="name"
                        value-field="id"
                    >
                        <template #first>
                            <b-form-select-option :value="null">
                                Select Any Type
                            </b-form-select-option>
                        </template>
                    </b-form-select>
                </b-col>
                <b-col md="4" cols="12">
                    <b-form-input
                        type="search"
                        placeholder="Search Master Items..."
                        v-model="query"
                    ></b-form-input>
                </b-col>

                <b-col md="4" cols="12">
                    <slot></slot>
                </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <p class="mt-3">
                Page: {{ pagination.page }} of {{ pageCount }} Total:
                {{ pagination.total }}
            </p>
            <b-table
                :fields="itemFields"
                striped
                hover
                responsive
                :items="items"
            >
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="viewItem(row.item.id)"
                        v-if="hasPermissionView"
                        class="mr-2"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>
            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="pagination.page"
                        :total-rows="pagination.total"
                        :per-page="pagination.pageSize"
                        aria-controls="assetTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>
        </b-card-body>
    </b-card>
</template>

<script>
import _ from 'lodash'
import reportMixins from '@/mixins/reportMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'MasterItems-ListItems',
    props: ['type', 'title'],
    mixins: [popupMixins, reportMixins, permissionsMixins],

    data() {
        return {
            reportType: 'master_item_details',
            filters: {
                order_item_type_id: null,
            },
            query: '',
            itemFields: [
                {
                    key: 'id',
                    label: '',
                    stickyColumn: true,
                },
                'name',

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                },
                {
                    key: 'order_item_type_id',
                    label: 'Type',
                    formatter: (value, key, item) =>
                        item.type && item.type.name,
                },
                {
                    key: 'vendor_id',
                    label: 'Vendor',
                    formatter: (value, key, item) =>
                        item.vendor && item.vendor.name,
                },

                {
                    key: 'ext_reference_code',
                    label: 'Code',
                    formatter: (value, key, item) => item.ext_reference_code,
                },

                {
                    key: 'uom',
                    label: 'UOM',
                    formatter: (value, key, item) => item.uom,
                },
                {
                    key: 'selling_price',
                    label: 'Price',
                    formatter: (value, key, item) => item.selling_price,
                },
            ],
        }
    },

    mounted() {
        console.log('items', this.items)
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        items() {
            const _items = this.$store.state.masterItem.items
            console.log('master items', _items)
            return _items
        },
        pagination() {
            return this.$store.state.masterItem.pagination || {}
        },

        types() {
            return this.$store.state.itemType.items.filter(x => !x.is_discount)
        },
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
        report_loading: function (val) {
            this.$emit('report-state', val)
        },
    },

    methods: {
        /*  generateReport() {
            this.$refs.detailsDialog.show(this.queryModel)
        }, */

        getQueryString(rpt_type) {
            const queryModel = {}
            queryModel.name = this.query
            queryModel.rpt_type = rpt_type
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },
        viewItem(id) {
            const path = `${this.$route.path}/${id}`
            this.$router.push({ path })
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            let {
                query,
                pagination: { page },
                filters,
            } = this
            if (!parseInt(filters.order_item_type_id, 10)) {
                filters.order_item_type_id = null
            }
            this.$store.dispatch('masterItem/fetch', {
                query,
                page,
                filters,
            })
        },
        deleteItem(id) {
            let item = this.items.find(el => el.id == id)

            const title = 'Delete Master Item?'
            const message = `Are you sure you want to delete ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('masterItem/delete', id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Your Item has been deleted.',
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete item!',
                                'danger'
                            )
                        })
                }
            })
        },
    },
}
</script>
<style></style>
